import { render, staticRenderFns } from "./IssuuModal.vue?vue&type=template&id=15826d00&scoped=true&"
import script from "./IssuuModal.vue?vue&type=script&lang=js&"
export * from "./IssuuModal.vue?vue&type=script&lang=js&"
import style0 from "./IssuuModal.vue?vue&type=style&index=0&id=15826d00&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15826d00",
  null
  
)

export default component.exports